export function anonymizeLastName(_lastName?: string | null): string {
  return '';
}

export function anonymizePersonName(person?: {
  firstName?: string | null;
  lastName?: string | null;
} | null): string {
  const first = (person?.firstName ?? '').trim();
  const last = (person?.lastName ?? '').trim();

  if (!first && !last) return 'Inconnu';
  if (!first) return last.charAt(0).toUpperCase() + '.' || 'Inconnu';

  return first;
}

export function anonymizeFullName(fullName?: string | null): string {
  const cleaned = (fullName ?? '').trim().replace(/\s+/g, ' ');
  if (!cleaned) return 'Inconnu';

  const parts = cleaned.split(' ').filter(Boolean);
  return parts[0] || 'Inconnu';
}
